// import { GoogleAnalyticsTracker } from "react-native-google-analytics-bridge";

import DebugLogger from "../../utils/DebugLogger";
// import Analytics from "../../utils/Analytics";
// import SessionHelper from "../../utils/SessionHelper";
import { Actions as SessionActions } from "../SessionRedux";

// let tracker = new GoogleAnalyticsTracker("UA-124203308-3");

const screenTracking = (store) => (next) => (action) => {
    let result = next(action);

    //var state = store.getState();
    DebugLogger.log("Redux: " + action.type + " is called.");

    try {
        if (action.type.endsWith("loadScreenViewSuccess")) {
            DebugLogger.log("View: " + action.type + " is loaded.");

            if (!action.data.analytics) {
                //throw new Error("Analytics data is not returned for screen (" + action.type + ")");
            }

            //Analytics.trackScreenView(action.data.analytics.uid, action.type, action.data.analytics.userProps, action.data.analytics.pageProps);

            const response = action.data;
            if (response) {
                // 如果响应包含 pendingRequests，则更新 SessionRedux
                if (response.pendingRequests) {
                    store.dispatch(SessionActions.updatePendingRequestsFromResponse(response.pendingRequests));
                }
                
                // 如果响应包含 myPendingRequests，则更新 SessionRedux
                if (response.myPendingRequests) {
                    store.dispatch(SessionActions.updateMyPendingRequests(response.myPendingRequests));
                }
            }
        }
    } catch (err) {
        DebugLogger.log("Screen view is NOT sent successfully due to " + err);
    }

    return result;
};

export default screenTracking;
